import { EnquiryFormsPermissions } from './enquiryForms.permissions';
import { EnquiryFormsRoles } from './enquiryForms.roles';

export const enquiryFormsMappings = {
  [EnquiryFormsPermissions.VIEW_ENQUIRY_FORMS]: [EnquiryFormsRoles.VIEWER],
  [EnquiryFormsPermissions.MANAGE_ENQUIRY_FORMS]: [EnquiryFormsRoles.MANAGER],
};
